import { Stage } from 'konva/lib/Stage';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export interface ElementSize {
  /** Shape group position (used for placement) */
  x: number;
  y: number;
  /** Explicitly set size on the Konva node */
  width: number;
  height: number;
  /** Visual bounding box position (may differ from x/y when children extend beyond origin) */
  visualX: number;
  visualY: number;
  /** Visual bounding box size (includes companions, labels, etc.) */
  visualWidth: number;
  visualHeight: number;
}

export const getElementSize = (
  shapeId: string,
  stageObject?: Stage
): ElementSize | null => {
  const stage = stageObject || getWindowKonvaObject().stages[0];
  if (!stage || !shapeId) return null;

  const shapeNode = stage.findOne(`#shape-${shapeId}`);
  if (!shapeNode) return null;

  const pos = shapeNode.getPosition();
  const size = shapeNode.getSize();
  // `skipStroke: true` so the half-pixel of a stroked outline doesn't
  // inflate visual width/height. Without it, downstream spacing math
  // (e.g. CMD+arrow duplicate gap) lands at e.g. 2.5px instead of the
  // intended 2px when shapes carry a 1px stroke.
  const rect = shapeNode.getClientRect({
    relativeTo: shapeNode.getParent() ?? undefined,
    skipStroke: true
  });

  return {
    x: pos.x,
    y: pos.y,
    width: size.width,
    height: size.height,
    visualX: rect.x,
    visualY: rect.y,
    visualWidth: rect.width,
    visualHeight: rect.height
  };
};
